// CONFIGURATION MENU DATA
export const configurationMenus = [
    {
        text: "General",
        icon: "menu",
        description: "Manage the general settings for your dashboard",
        permission: "",
        options: [
            { text: "departments", link: "departments", icon: "account_tree", description: "Manage internal departments", permission: "" },
            { text: "log_templates", link: "log_templates", icon: "article", description: "Manage log templates", permission: "" },
            { text: "manufacturers", link: "manufacturers", icon: "precision_manufacturing", description: "Configure manufacturers", permission: "" },
            { text: "options", link: "options_categories", icon: "list", description: "Manage options for auto complete fields", permission: "" },
            { text: "fe_part_categories", link: "fe_part_categories", icon: "tag", description: "Manage part categories", permission: "" },
            // { text: 'help_articles', link: 'settings_help_articles', icon: 'article', description: 'Manage system help articles' },
            // { text: 'create_notification', link: 'settings_create_notification', icon: 'notifications', description: 'Define customize notifications' },
            // { text: 'configure_environment', link: 'settings_configure_environment', icon: 'settings', description: 'Manage specific settings for this device'},
            { text: "shipping_carriers", link: "shipping_carriers", icon: "local_shipping", description: "Configure shipping companies", permission: "" },
            { text: "units_of_measure", link: "units_of_measure", icon: "straighten", description: "Configure units of measure", permission: "" },
            { text: "vendors", link: "vendors", icon: "sell", description: "Configure vendors", permission: "" },
        ],
    },
    {
        text: "Financial",
        icon: "payments",
        description: "Manage the financial settings for your dashboard",
        permission: "",
        options: [
            { text: "bank_accounts", link: "bank_accounts", icon: "account_balance", description: "Configure Bank Accounts", permission: "" },
            { text: "chart_of_accounts", link: "chart_of_accounts", icon: "format_list_bulleted", description: "Configure Chart of Accounts", permission: "" },

            { text: "currency", link: "currencies", icon: "attach_money", description: "Configure Currency", permission: "" },
            { text: "exchange_rates", link: "exchange_rates", icon: "currency_exchange", description: "Configure Exchange Rates", permission: "" },
            { text: "payment_terms", link: "payment_terms", icon: "gavel", description: "Payment terms for customers/suppliers", permission: "" },
        ],
    },
    {
        text: "Production",
        icon: "shopping_cart",
        description: "Manage production for your dashboard",
        permission: "",
        options: [
            { text: "machines", link: "settings_machines", icon: "precision_manufacturing", description: "Define machines", permission: "" },
            {
                text: "nonconformance_types",
                link: "settings_nonconformance_types",
                icon: "report",
                description: "Define types of nonconformances",
                permission: "",
            },
            { text: "parts_spec_types", link: "settings_parts_spec_type", icon: "note_alt", description: "Define specification types for QC", permission: "" },
            { text: "production_lines", link: "settings_production_lines", icon: "multiple_stop", description: "Define production lines", permission: "" },
            { text: "production_stations", link: "settings_production_stations", icon: "pin_drop", description: "Define production stations", permission: "" },
        ],
    },
    {
        text: "Security",
        icon: "lock",
        description: "Manage security for your dashboard",
        options: [
            { text: "active_sessions", link: "settings_active_sessions", icon: "bolt", description: "Quickly view and/or terminate sessions", permission: "" },
            { text: "login_attempts", link: "settings_login_attempts", icon: "lock_clock", description: "Identify and manage login threats", permission: "" },
            {
                text: "permission_templates",
                link: "settings_permission_templates",
                icon: "edit_note",
                description: "Define custom permission templates",
                permission: "",
            },
        ],
    },
    {
        text: "Developer",
        icon: "api",
        description: "Manage core system settings",
        permission: "",
        options: [
            { text: "dashboard_widgets", link: "dashboard_widgets", icon: "widgets", description: "Manage dashboard widgets", permission: "" },
            { text: "data_import_logs", link: "data_import_logs", icon: "cloud_upload", description: "Manage data imports", permission: "" },
            { text: "form_builder", link: "settings_form_builder", icon: "post_add", description: "Manage form validation", permission: "" },
            { text: "languages", link: "settings_languages", icon: "translate", description: "Setup & configure languages", permission: "" },
            { text: "mysql", link: "settings_mysql", icon: "dns", description: "Manage database tables", permission: "" },
            { text: "permissions", link: "settings_permissions", icon: "lock", description: "Manage base user permissions", permission: "" },
        ],
    },
];
